import React from "react";
import type { FC, PropsWithChildren } from "react";

import cn from "classnames";

import ButtonsViewStack from "./components/Stack/ButtonsViewStack";

import type { ButtonsViewProps } from "./types";

import classes from "./ButtonsView.styl";

const BUTTONS_VIEW_DISPLAY_NAME = "ButtonsView";

/**
 * Контейнер для отображения нескольких рядов ButtonsStack с вертикальным автолейаутом
 * для реализации любых сложных конструкций, содержащих только компоненты Button.
 * Систематизирует динамические отступы между компонентами.
 *
 * <a href="https://www.figma.com/design/LYZAXE33pUg2cSL5mmUHYq/%F0%9F%8D%91-Buttons-%26-Tabs-%26-Chips?m=auto&node-id=2-283476&t=AblUbhRcVwNj1IJ3-1" target="_blank">Спека</a>
 */
const ButtonsView: FC<PropsWithChildren<ButtonsViewProps>> = ({
    view = "primary",
    size = "56",
    subhead,
    description,
    fill = true,
    customVarsStyles,
    "data-tsid": tsid,
    children,
}) => {
    const showAdditionalTexts = size === "56";

    return (
        <div
            className={cn(classes["buttons-view"], customVarsStyles)}
            data-tsid={tsid}
            data-uikit={BUTTONS_VIEW_DISPLAY_NAME}
        >
            {showAdditionalTexts && subhead && (
                <h2
                    className={cn(
                        classes["text"],
                        classes["__subhead"],
                        classes[`__view-${view}`],
                    )}
                >
                    {subhead}
                </h2>
            )}
            <ButtonsViewStack view="vertical" size={size} fillButtons={fill}>
                {children}
            </ButtonsViewStack>
            {showAdditionalTexts && description && (
                <p
                    className={cn(
                        classes["text"],
                        classes["__description"],
                        classes[`__view-${view}`],
                    )}
                >
                    {description}
                </p>
            )}
        </div>
    );
};

ButtonsView.displayName = BUTTONS_VIEW_DISPLAY_NAME;

export default ButtonsView;
